// Where the deck designer's admin entities are served (see createAdminCrudApi).
export const DECK_ADMIN_URL = "/admin/modules/deck_designer";
